import React, { forwardRef } from 'react'
import { makeStyles, Paper as MuiPaper, PaperProps as MuiPaperProps } from '@material-ui/core'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    '&:last-child': {
      marginBottom: 0,
    },
    marginBottom: spacing(4),
    padding: spacing(4),
  },
}))

export interface PaperProps extends MuiPaperProps {
  legacyStyles?: boolean
}

export const Paper = forwardRef<HTMLDivElement, PaperProps>(({ legacyStyles = false, ...restProps }, ref) => {
  const classes = useStyles({ ...restProps, legacyStyles })
  return <MuiPaper ref={ref} classes={{ ...(legacyStyles && classes) }} {...restProps} />
})

Paper.displayName = 'Paper'
